import styled from 'styled-components'

import { tokens } from '@styles/tokens'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 100vh;
  padding: 24px;
  text-align: center;
`

export const Title = styled.h1`
  font-size: 24px;
  color: ${tokens.palette.ink};
  font-weight: ${tokens.fontWeight.bold};
  margin: 0;
`

export const Message = styled.p`
  font-size: 16px;
  color: #555;
  margin: 0;
  max-width: 400px;
`

export const ReloadButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: ${tokens.radius.sm};
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%),
    ${tokens.palette.primaryStrong};
  background-blend-mode: soft-light, normal;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: transform ${tokens.transition.fast}, box-shadow ${tokens.transition.fast},
    background ${tokens.transition.fast};

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${tokens.shadow.sm};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${tokens.focusRing};
  }
`
